var _rect, _g, _mask, _path, _path2, _mask2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 320,
    viewBox: "0 0 378 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_298_8088",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 56,
    width: 377,
    height: 262
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 56.2581,
    width: 377,
    height: 260.911,
    rx: 19,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_298_8088)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.404319,
    filter: "url(#filter0_f_298_8088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -33.8008,
    y: 24.439,
    width: 498.8,
    height: 57.2731,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.156151,
    filter: "url(#filter1_f_298_8088)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.804689 43.5303C4.1184 43.5303 6.80469 46.2166 6.80469 49.5303L6.80469 330.259C6.80469 333.573 4.1184 336.259 0.804687 336.259H-4.59531C-7.90902 336.259 -10.5953 333.573 -10.5953 330.259L-10.5953 49.5303C-10.5953 46.2166 -7.90902 43.5303 -4.59531 43.5303H0.804689Z",
    fill: "white"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_298_8088",
    maskUnits: "userSpaceOnUse",
    x: 115.084,
    y: 0,
    width: 149,
    height: 57,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 115.084,
    width: 149,
    height: 57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.916 56.368V7.152C262.916 5.52039 259.048 3.9556 252.164 2.80188C245.28 1.64815 235.943 1 226.208 1H152.792C143.056 1 133.72 1.64815 126.835 2.80188C119.951 3.9556 116.084 5.52039 116.084 7.152V56.368"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.916 56.368V7.152C262.916 5.52039 259.048 3.9556 252.164 2.80188C245.28 1.64815 235.943 1 226.208 1H152.792C143.056 1 133.72 1.64815 126.835 2.80188C119.951 3.9556 116.084 5.52039 116.084 7.152V56.368",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 7.152H115.334H116.084ZM263.666 56.368V7.152H262.166V56.368H263.666ZM263.666 7.152C263.666 6.4254 263.234 5.83122 262.686 5.37147C262.13 4.90551 261.35 4.48578 260.403 4.10248C258.501 3.33312 255.751 2.64263 252.288 2.06219L252.04 3.54156C255.461 4.11485 258.087 4.78362 259.84 5.49298C260.72 5.84905 261.337 6.19855 261.722 6.52093C262.114 6.84952 262.166 7.06279 262.166 7.152H263.666ZM252.288 2.06219C245.351 0.899518 235.97 0.25 226.208 0.25V1.75C235.917 1.75 245.209 2.39679 252.04 3.54156L252.288 2.06219ZM226.208 0.25H152.792V1.75H226.208V0.25ZM152.792 0.25C143.03 0.25 133.649 0.899518 126.712 2.06219L126.959 3.54156C133.79 2.39679 143.083 1.75 152.792 1.75V0.25ZM126.712 2.06219C123.248 2.64263 120.498 3.33312 118.597 4.10248C117.65 4.48578 116.87 4.90551 116.314 5.37147C115.766 5.83122 115.334 6.4254 115.334 7.152H116.834C116.834 7.06279 116.886 6.84952 117.278 6.52093C117.662 6.19855 118.279 5.84905 119.16 5.49298C120.913 4.78362 123.539 4.11485 126.959 3.54156L126.712 2.06219ZM115.334 7.152V56.368H116.834V7.152H115.334Z",
    fill: "url(#paint0_linear_298_8088)",
    mask: "url(#path-4-outside-1_298_8088)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_298_8088",
    maskUnits: "userSpaceOnUse",
    x: 125.006,
    y: 9.88721,
    width: 129,
    height: 47,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 125.006,
    y: 9.88721,
    width: 129,
    height: 47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.995 56.3681V15.9406C252.995 14.6004 249.651 13.315 243.697 12.3673C237.743 11.4196 229.668 10.8872 221.248 10.8872H157.753C149.333 10.8872 141.258 11.4196 135.304 12.3673C129.351 13.315 126.006 14.6004 126.006 15.9406V56.3681"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.995 56.3681V15.9406C252.995 14.6004 249.651 13.315 243.697 12.3673C237.743 11.4196 229.668 10.8872 221.248 10.8872H157.753C149.333 10.8872 141.258 11.4196 135.304 12.3673C129.351 13.315 126.006 14.6004 126.006 15.9406V56.3681",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.006 15.9406H125.256H126.006ZM253.745 56.3681V15.9406H252.245V56.3681H253.745ZM253.745 15.9406C253.745 15.2704 253.327 14.7462 252.847 14.3635C252.354 13.9713 251.67 13.6226 250.848 13.3067C249.196 12.6718 246.812 12.1037 243.815 11.6266L243.579 13.108C246.536 13.5786 248.801 14.127 250.31 14.7069C251.068 14.9983 251.592 15.2814 251.912 15.5369C252.071 15.6628 252.158 15.7655 252.204 15.8381C252.246 15.9057 252.245 15.9367 252.245 15.9406H253.745ZM243.815 11.6266C237.81 10.6708 229.693 10.1372 221.248 10.1372V11.6372C229.643 11.6372 237.676 12.1684 243.579 13.108L243.815 11.6266ZM221.248 10.1372H157.753V11.6372H221.248V10.1372ZM157.753 10.1372C149.308 10.1372 141.191 10.6708 135.187 11.6266L135.422 13.108C141.325 12.1684 149.359 11.6372 157.753 11.6372V10.1372ZM135.187 11.6266C132.19 12.1037 129.806 12.6718 128.153 13.3067C127.331 13.6226 126.647 13.9713 126.154 14.3635C125.674 14.7462 125.256 15.2704 125.256 15.9406H126.756C126.756 15.9367 126.755 15.9057 126.798 15.8381C126.843 15.7655 126.931 15.6628 127.089 15.5369C127.409 15.2814 127.933 14.9983 128.692 14.7069C130.2 14.127 132.466 13.5786 135.422 13.108L135.187 11.6266ZM125.256 15.9406V56.3681H126.756V15.9406H125.256Z",
    fill: "url(#paint1_linear_298_8088)",
    mask: "url(#path-6-outside-2_298_8088)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.729 56.3186H38.5255C17.5948 56.3186 0.625 73.2286 0.625 94.0908V281.077C0.625 301.939 17.5948 318.849 38.5255 318.849H338.729C359.66 318.849 376.63 301.939 376.63 281.077V94.0908C376.63 73.2286 359.66 56.3186 338.729 56.3186Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "url(#paint2_linear_298_8088)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_298_8088",
    x: -58.2653,
    y: -0.0255718,
    width: 547.73,
    height: 106.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2323,
    result: "effect1_foregroundBlur_298_8088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_298_8088",
    x: -14.6731,
    y: 39.4529,
    width: 25.5552,
    height: 300.884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.03871,
    result: "effect1_foregroundBlur_298_8088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_8088",
    x1: 116.084,
    y1: -6.212,
    x2: 110.331,
    y2: 52.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B",
    stopOpacity: 0.516361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224563,
    stopColor: "#797979",
    stopOpacity: 0.463172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_8088",
    x1: 126.006,
    y1: 4.96306,
    x2: 121.514,
    y2: 53.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B",
    stopOpacity: 0.516361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224563,
    stopColor: "#797979",
    stopOpacity: 0.463172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_8088",
    x1: 0.999996,
    y1: 22.5952,
    x2: -48.179,
    y2: 293.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B",
    stopOpacity: 0.516361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224563,
    stopColor: "#797979",
    stopOpacity: 0.463172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.c3df5cce9e215007f738b91bb5dcf8be.svg";
export { ForwardRef as ReactComponent };